import React, { useState, useEffect } from 'react'
import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import Zemelapis from '../components/Zemelapis'
import { arIssaugota, perjungtiIssaugota } from '../utils/issaugotos'
import { arAplankyta } from '../utils/aplankytos'
import { fiksuotiKelia } from '../utils/kelias'
import { getNavigacija, setNavigacija, atidarytiNavigacija as atidarytiNav } from '../utils/navigacija'
import NavigacijaPasirinkimas from '../components/NavigacijaPasirinkimas'
import CoachMark from '../components/CoachMark'
import { arMatyta, pazymetiMatyta, pazymetiMatytaKeli } from '../utils/onboarding'
import { ivykis } from '../utils/matavimas'

delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

const KATEGORIJU_PAVADINIMAI = {
  gamta: 'Gamta', 'jūra': 'Jūra', jura: 'Jūra', istorija: 'Istorija', miestas: 'Miestas', veikla: 'Veikla'
}

function gauti_statusa(darboLaikas) {
  if (!darboLaikas) return null
  const dabar = new Date()
  const dabarMin = dabar.getHours() * 60 + dabar.getMinutes()
  const m = darboLaikas.match(/(\d{1,2}):(\d{2})\s*[-–]\s*(\d{1,2}):(\d{2})/)
  if (!m) return null
  const atidaro = parseInt(m[1]) * 60 + parseInt(m[2])
  const uzdaro = parseInt(m[3]) * 60 + parseInt(m[4])
  return dabarMin >= atidaro && dabarMin < uzdaro
    ? { atvira: true, tekstas: `atvira iki ${m[3]}:${m[4]}` }
    : { atvira: false, tekstas: `uždaryta iki ${m[1]}:${m[2]}` }
}

function ZemelapioCentras({ lat, lng }) {
  const map = useMap()
  useEffect(() => { map.setView([lat, lng], 13, { animate: false }) }, [lat, lng, map])
  return null
}

function RuleteRezultatas({ vieta, vietos, kitos, lokacija, rankinis, onUzdaryti, onKita, onAplankyta }) {
  const [issaugota, setIssaugota] = useState(() => arIssaugota(vieta.id))
  const [rezimas, setRezimas] = useState('nuotrauka')
  const touchStartY = React.useRef(null)
  const [navPasirinkimas, setNavPasirinkimas] = useState(false)
  const [navigacija, setNav] = useState(() => getNavigacija())
  const laikymoTaimeris = React.useRef(null)
  const paspausta = React.useRef(false)
  const handleRef = React.useRef(null)
  const keliasRef = React.useRef(null)
  const [rezZingsnis, setRezZingsnis] = useState(-1)

  // Onboarding: rezultato ekrano seka (kortelė + kelias iki čia) — kartą
  useEffect(() => {
    if (!arMatyta('ob_kortele')) {
      const t = setTimeout(() => setRezZingsnis(0), 650)
      return () => clearTimeout(t)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const REZ_ZINGSNIAI = [
    { id: 'ob_kortele', ref: handleRef, rodykle: 'up', antraste: 'Vietos kortelė', tekstas: 'Patrauk kortelę viršun — atsidaro žemėlapis su ta vieta.' },
    { id: 'ob_kelias', ref: keliasRef, antraste: 'Kelias iki čia', tekstas: 'Veda į navigaciją. Palaikyk mygtuką, jei nori pakeisti programą — Google Maps, Waze ar Apple Maps.' },
  ]
  function rezKitas() {
    const z = REZ_ZINGSNIAI[rezZingsnis]
    if (z) pazymetiMatyta(z.id)
    setRezZingsnis(rezZingsnis >= REZ_ZINGSNIAI.length - 1 ? -1 : rezZingsnis + 1)
  }
  function rezPraleisti() {
    pazymetiMatytaKeli(REZ_ZINGSNIAI.map(z => z.id))
    setRezZingsnis(-1)
  }

  // Užfiksuojam realaus kelio km, kai vieta atidaroma (dažniausiai geras signalas).
  // Įrašom lokaliai; globalus „Buvau čia" vėliau tiesiog įskaito (veikia ir be interneto).
  useEffect(() => {
    if (!lokacija || arAplankyta(vieta.id)) return
    fiksuotiKelia(vieta.id, { lat: lokacija.lat, lng: lokacija.lng }, { lat: vieta.latitude, lng: vieta.longitude })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const kategorija = KATEGORIJU_PAVADINIMAI[vieta.kategorija] || vieta.kategorija
  const nuotrauka = vieta.nuotraukos?.[0] || vieta.nuotrauka_url
  const statusas = gauti_statusa(vieta.darbo_laikas)

  const gintaroPin = React.useMemo(() => L.divIcon({
    className: '',
    html: `<svg width="28" height="28" viewBox="0 0 28 28"><circle cx="14" cy="14" r="14" fill="#E5A840"/><circle cx="14" cy="14" r="5" fill="#141F1A"/></svg>`,
    iconSize: [28, 28], iconAnchor: [14, 14]
  }), [])

  // Paleidžia navigaciją į vietą. Jei pagrindinė dar nepasirinkta — atidaro pasirinkimą.
  function keliasIkiCia() {
    const nav = getNavigacija()
    if (!nav) { setNavPasirinkimas(true); return }
    ivykis('navigacija', vieta.id, { programa: nav })
    atidarytiNav(nav, vieta.latitude, vieta.longitude)
  }

  function pasirinktiNavigacija(id) {
    setNavigacija(id)
    setNav(id)
    setNavPasirinkimas(false)
    ivykis('navigacija', vieta.id, { programa: id, pirmas_pasirinkimas: true })
    atidarytiNav(id, vieta.latitude, vieta.longitude)
  }

  // Palaikymas ant mygtuko — atidaro pasirinkimą pakeisti navigacijai
  function pradetiLaikyma() {
    paspausta.current = false
    laikymoTaimeris.current = setTimeout(() => { paspausta.current = true; setNavPasirinkimas(true) }, 500)
  }
  function baigtiLaikyma() {
    if (laikymoTaimeris.current) { clearTimeout(laikymoTaimeris.current); laikymoTaimeris.current = null }
  }

  function dalintis() {
    if (navigator.share) navigator.share({ title: vieta.pavadinimas, url: `https://klajok.com/v/${vieta.id}` })
    else navigator.clipboard.writeText(`https://klajok.com/v/${vieta.id}`)
  }

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 100, background: '#141F1A' }}>
      <style>{`
        @keyframes rezultatasIeina {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
      `}</style>
      {/* Turinys fade'inasi virš visada tamsaus fono — jokio balto žemėlapio pro šalį */}
      <div style={{ position: 'absolute', inset: 0, animation: 'rezultatasIeina 0.5s ease-out' }}>

      {/* NUOTRAUKA */}
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '45%', background: '#1E2E27', transform: rezimas === 'zemelapis' ? 'translateY(-33%)' : 'translateY(0)', transition: 'transform 0.4s cubic-bezier(0.32,0.72,0,1)' }}>

        {/* Nuotrauka */}
        <div style={{ position: 'absolute', inset: 0, opacity: rezimas === 'nuotrauka' ? 1 : 0, transition: 'opacity 0.4s ease', pointerEvents: rezimas === 'nuotrauka' ? 'auto' : 'none' }}>
          {nuotrauka && <img src={nuotrauka} alt={vieta.pavadinimas} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
        </div>

        {/* Žemėlapis */}
        <div style={{ position: 'absolute', inset: 0, opacity: rezimas === 'zemelapis' ? 1 : 0, transition: 'opacity 0.4s ease', pointerEvents: rezimas === 'zemelapis' ? 'auto' : 'none' }}>
          <Zemelapis
            vietos={vietos || []}
            lokacija={lokacija}
            onVietaPasirinkta={(v) => onKita(v)}
            pasirinkta={vieta}
            aktyviosKategorijos={[]}
            pradiniscentras={{ lat: vieta.latitude, lng: vieta.longitude }}
            piestiLinija={false}
          />
        </div>

        {/* Mygtukai */}
        <div style={{ position: 'absolute', top: 16, left: 16, right: 16, display: 'flex', justifyContent: 'space-between', zIndex: 10 }}>
          <button onClick={onUzdaryti} style={{ width: 40, height: 40, borderRadius: '50%', background: 'rgba(20,31,26,0.75)', backdropFilter: 'blur(10px)', border: '1px solid rgba(240,232,213,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#F0E8D5' }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
          </button>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={dalintis} style={{ width: 40, height: 40, borderRadius: '50%', background: 'rgba(20,31,26,0.75)', backdropFilter: 'blur(10px)', border: '1px solid rgba(240,232,213,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#F0E8D5' }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg>
            </button>
            <button onClick={() => setIssaugota(perjungtiIssaugota(vieta))} style={{ width: 40, height: 40, borderRadius: '50%', background: issaugota ? 'rgba(229,168,64,0.2)' : 'rgba(20,31,26,0.75)', backdropFilter: 'blur(10px)', border: `1px solid ${issaugota ? 'rgba(229,168,64,0.5)' : 'rgba(240,232,213,0.15)'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: issaugota ? '#E5A840' : '#F0E8D5', transition: 'all 0.2s ease' }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill={issaugota ? '#E5A840' : 'none'} stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21l-7-5-7 5V5.2c0-1.2.9-2.2 2-2.2h10c1.1 0 2 1 2 2.2z"/></svg>
            </button>
          </div>
        </div>
      </div>

      {/* LENTELE */}
      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '72%', display: 'flex', flexDirection: 'column', background: '#141F1A', borderRadius: '20px 20px 0 0', zIndex: 10, transform: rezimas === 'zemelapis' ? 'translateY(0)' : 'translateY(21%)', transition: 'transform 0.4s cubic-bezier(0.32,0.72,0,1)' }}>

        {/* Handle — fiksuotas viršuje */}
        <div
          ref={handleRef}
          style={{ display: 'flex', justifyContent: 'center', padding: '16px 0 10px', flexShrink: 0, cursor: 'ns-resize' }}
          onMouseDown={(e) => { touchStartY.current = e.clientY }}
          onMouseUp={(e) => {
            if (touchStartY.current === null) return
            const delta = e.clientY - touchStartY.current
            touchStartY.current = null
            if (delta < -40) setRezimas('zemelapis')
            else if (delta > 40) setRezimas('nuotrauka')
          }}
          onTouchStart={(e) => { touchStartY.current = e.touches[0].clientY }}
          onTouchEnd={(e) => {
            if (touchStartY.current === null) return
            const delta = e.changedTouches[0].clientY - touchStartY.current
            touchStartY.current = null
            if (delta < -40) setRezimas('zemelapis')
            else if (delta > 40) setRezimas('nuotrauka')
          }}
        >
          <div style={{ width: 36, height: 4, background: rezimas === 'zemelapis' ? 'rgba(229,168,64,0.5)' : 'rgba(240,232,213,0.2)', borderRadius: 2, transition: 'background 0.3s ease' }} />
        </div>

        {/* Turinys — slenkamas */}
        <div style={{ flex: 1, overflowY: 'auto', scrollbarWidth: 'none', padding: '0 20px 32px', overflow: 'hidden auto' }}>

        {/* Meta */}
        <p style={{ color: '#B0B8A8', fontSize: 12, marginBottom: 6, letterSpacing: '0.02em' }}>
          {kategorija}
          {statusas && <span style={{ color: statusas.atvira ? '#7FB369' : '#C86353' }}> · {statusas.tekstas}</span>}
        </p>

        {/* Antraštė */}
        <h1 style={{ fontFamily: "'Lora', Georgia, serif", color: '#F0E8D5', fontSize: 26, fontWeight: 500, letterSpacing: '-0.01em', lineHeight: 1.15, marginBottom: 10 }}>
          {vieta.pavadinimas}
        </h1>

        {/* Chip'ai */}
        <div style={{ display: 'flex', gap: 6, marginBottom: 14, flexWrap: 'wrap' }}>
          {vieta.tinka_vaikams && <span style={{ padding: '4px 10px', borderRadius: 999, fontSize: 11, background: 'rgba(229,168,64,0.14)', color: '#E5A840' }}>vaikams</span>}
          {vieta.nemokama && <span style={{ padding: '4px 10px', borderRadius: 999, fontSize: 11, background: 'rgba(240,232,213,0.08)', color: '#F0E8D5' }}>nemokama</span>}
        </div>

        {/* Aprašymas */}
        {vieta.aprasymas && <p style={{ color: '#B0B8A8', fontSize: 13, lineHeight: 1.55, marginBottom: 18 }}>{vieta.aprasymas}</p>}

        {/* CTA */}
        <button
          ref={keliasRef}
          onClick={() => { if (paspausta.current) { paspausta.current = false; return } keliasIkiCia() }}
          onPointerDown={pradetiLaikyma}
          onPointerUp={baigtiLaikyma}
          onPointerLeave={baigtiLaikyma}
          onContextMenu={(e) => e.preventDefault()}
          style={{ width: '100%', height: 52, borderRadius: 10, background: '#E5A840', color: '#141F1A', fontFamily: 'Syne, system-ui, sans-serif', fontSize: 14, fontWeight: 600, border: 'none', cursor: 'pointer', marginBottom: 20, touchAction: 'manipulation' }}
        >
          Kelias iki čia
        </button>

        {/* Kitos rekomendacijos */}
        {kitos && kitos.length > 0 && (
          <div style={{ marginBottom: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
              <div style={{ flex: 1, height: 1, background: '#2A3B32' }} />
              <span style={{ color: '#7A8A7E', fontSize: 10, letterSpacing: '0.1em', textTransform: 'uppercase' }}>Kitos rekomendacijos</span>
              <div style={{ flex: 1, height: 1, background: '#2A3B32' }} />
            </div>
            <div style={{ display: 'flex', gap: 10, overflowX: 'auto', paddingBottom: 4, scrollbarWidth: 'none' }}>
              {kitos.map(k => (
                <div
                  key={k.id}
                  onClick={() => setTimeout(() => onKita(k), 150)}
                  onPointerDown={(e) => { e.currentTarget.style.transform = 'scale(0.95)' }}
                  onPointerUp={(e) => { e.currentTarget.style.transform = 'scale(1)' }}
                  onPointerLeave={(e) => { e.currentTarget.style.transform = 'scale(1)' }}
                  style={{ flexShrink: 0, width: 140, cursor: 'pointer', transition: 'transform 0.18s ease' }}
                >
                  <div style={{ width: '100%', height: 90, borderRadius: 8, marginBottom: 8, overflow: 'hidden', background: '#1E2E27' }}>
                    {(k.nuotraukos?.[0] || k.nuotrauka_url) && <img src={k.nuotraukos?.[0] || k.nuotrauka_url} alt={k.pavadinimas} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
                  </div>
                  <p style={{ color: '#F0E8D5', fontSize: 12, fontWeight: 500, marginBottom: 3, lineHeight: 1.25, fontFamily: "'Lora', Georgia, serif" }}>{k.pavadinimas}</p>
                  <p style={{ color: '#7A8A7E', fontSize: 10 }}>{KATEGORIJU_PAVADINIMAI[k.kategorija] || k.kategorija}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Vežk kitur — tik ruletės režime (rankiniame rinkimesi nerodom) */}
        {!rankinis && <button onClick={() => onKita()} style={{ width: '100%', padding: 12, borderRadius: 8, background: 'transparent', color: '#7A8A7E', border: 'none', fontFamily: 'Syne, system-ui, sans-serif', fontSize: 12, cursor: 'pointer', letterSpacing: '0.04em' }}>
          Vežk kitur ↻
        </button>}

        </div>
      </div>
      </div>

      <NavigacijaPasirinkimas
        atidaryta={navPasirinkimas}
        dabartine={navigacija}
        onPasirinkti={pasirinktiNavigacija}
        onClose={() => setNavPasirinkimas(false)}
      />

      {rezZingsnis >= 0 && !navPasirinkimas && (
        <CoachMark
          key={REZ_ZINGSNIAI[rezZingsnis].id}
          targetRef={REZ_ZINGSNIAI[rezZingsnis].ref}
          rodykle={REZ_ZINGSNIAI[rezZingsnis].rodykle}
          antraste={REZ_ZINGSNIAI[rezZingsnis].antraste}
          tekstas={REZ_ZINGSNIAI[rezZingsnis].tekstas}
          zingsnis={`${rezZingsnis + 1} / ${REZ_ZINGSNIAI.length}`}
          paskutinis={rezZingsnis === REZ_ZINGSNIAI.length - 1}
          onKitas={rezKitas}
          onPraleisti={rezPraleisti}
        />
      )}
    </div>
  )
}

export default RuleteRezultatas
